const parsers = {
  // break on separator if present
  // month, day and year required
  // hours and minutes must both be present if time is specified
  'MM/DD/YYThh:mm:ss': /^(\d\d)\/(\d\d)\/(\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  'MM/DD/YYThhmmss': /^(\d\d)\/(\d\d)\/(\d\d)([^0-9](\d\d)(\d\d)(\d\d)?)?$/,
  'MM/DD/YYYYThh:mm:ss': /^(\d\d)\/(\d\d)\/(\d\d\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  'MM/DD/YYYYThhmmss': /^(\d\d)\/(\d\d)\/(\d\d\d\d)([^0-9](\d\d)(\d\d)(\d\d)?)?$/,
  MMDDYYThhmmss: /^(\d\d)(\d\d)(\d\d)([^0-9](\d\d)(\d\d)(\d\d)?)?$/,
  'MMDDYYYYThh:mm:ss': /^(\d\d)(\d\d)(\d\d\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  MMDDYYYYThhmmss: /^(\d\d)(\d\d)(\d\d\d\d)([^0-9](\d\d)(\d\d)(\d\d)?)?$/,
  'YYMMDDThh:mm:ss': /^(\d\d)(\d\d)(\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  YYMMDDThhmmss: /^(\d\d)(\d\d)(\d\d)([^0-9](\d\d)(\d\d)((\d\d))?)?$/,
  'YYYY-MM-DDThh:mm:ss': /^(\d\d\d\d)-(\d\d)-(\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  'YYYY-MM-DDThhmmss': /^(\d\d\d\d)-(\d\d)-(\d\d)([^0-9](\d\d)(\d\d)((\d\d))?)?$/,
  'YYYYMMDDThh:mm:ss': /^(\d\d\d\d)(\d\d)(\d\d)([^0-9](\d\d):(\d\d)(:(\d\d))?)?$/,
  YYYYMMDDThhmmss: /^(\d\d\d\d)(\d\d)(\d\d)([^0-9](\d\d)(\d\d)((\d\d))?)?$/,
}

//using new Date(year, monthIndex [, day [, hours [, minutes [, seconds [,
const constructors = {
  'MM/DD/YYThh:mm:ss': r =>
    new Date('20' + r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[8] || null),
  'MM/DD/YYThhmmss': r =>
    new Date('20' + r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[7] || null),
  'MM/DD/YYYYThh:mm:ss': r =>
    new Date(r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[8] || null),
  'MM/DD/YYYYThhmmss': r =>
    new Date(r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[8] || null),
  MMDDYYThhmmss: r => new Date(20 + r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[7] || null),

  'MMDDYYYYThh:mm:ss': r => {
    return new Date(r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[8] || null)
  },
  MMDDYYYYThhmmss: r => new Date(r[3], r[1] - 1, r[2], r[5] || null, r[6] || null, r[7] || null),

  'YYMMDDThh:mm:ss': r =>
    new Date(20 + r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[8] || null),
  YYMMDDThhmmss: r => new Date(20 + r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[7] || null),

  'YYYY-MM-DDThh:mm:ss': r =>
    new Date(r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[8] || null),

  'YYYY-MM-DDThhmmss': r =>
    new Date(r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[7] || null),

  'YYYYMMDDThh:mm:ss': r =>
    new Date(r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[8] || null),

  YYYYMMDDThhmmss: r => new Date(r[1], r[2] - 1, r[3], r[5] || null, r[6] || null, r[7] || null),
}

const validDate = (string, format) => {
  const standardizedFormat = format.replace(' ', 'T')
  const parser = parsers[standardizedFormat]
  if (!parser) {
    console.error('no parser for format', format)
    return false
  } else {
    return parser.test(string)
  }
}

const parseDate = (string, format) => {
  const standardizedFormat = format.replace(' ', 'T')
  const parser = parsers[standardizedFormat]
  if (!parser) {
    console.error('no parser for format', format)
    return null
  } else {
    if (validDate(string, format)) {
      return constructors[standardizedFormat](parser.exec(string))
    } else {
      console.error('invalid date', string, 'for format', standardizedFormat)
      return null
    }
  }
}

export { validDate, parseDate }
